/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';

export default class IndexRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    let year = moment().year();
    // For our Roll Return Test School (DEV+STAGING) query for next year's dates
    if (
      this.get('session.school.id') === '5250917d-7b78-4295-8306-72097571f43d'
    ) {
      year++;
    }
    return hash({
      dates: this.store.query('nz-roll-returns/return-date', {
        year,
      }),
      returns: this.store.query('nz-roll-returns/roll-return', {
        validateOnly: false,
      }),
      validations: this.store.query('nz-roll-returns/roll-return', {
        validateOnly: true,
      }),
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
